<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Pesquisar Projetos'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container  @keyup.enter="pesquisar()">

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm2>
                    <v-text-field
                      label='Número'
                      v-model="pesquisa.numero"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm9>
                    <v-text-field
                      label='Título'
                      v-model="pesquisa.titulo"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Classificação Primária'
                      :items="listaTipo"
                      v-model="pesquisa.tipoProjeto"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      readonly
                      autocomplete>
                    </v-select>
                  </v-flex>

                  <v-flex xs11 sm5>
                    <v-select
                      label='Classificação Secundária'
                      :items="listaSubtipo"
                      v-model="pesquisa.subtipoProjeto"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Palavra-chave'
                      v-model="pesquisa.palavraChave"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Membro da equipe'
                      v-model="pesquisa.membroEquipe"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select v-if="administrador===true || usuarioPROEX===true"
                      label='Situação'
                      :items="listaSituacao"
                      v-model="pesquisa.situacao"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      max-height="400"
                      chips
                      multiple
                      >
                    </v-select>
                    <v-select v-else
                      label='Situação'
                      :items="listaSituacao2"
                      v-model="pesquisa.situacao"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      max-height="400"
                      chips
                      multiple
                      >
                    </v-select>
                  </v-flex>

                  <v-flex xs11 sm5>
                    <v-select
                      label='Função do membro da equipe'
                      :items="listaFuncaoParticipante"
                      v-model="pesquisa.funcaoParticipante"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout v-if="pesquisaAvancada" row wrap justify-space-between>
                  <v-flex>
                    <v-text-field
                      label='Pesquisa ampliada'
                      v-model="pesquisa.multiplosCampos"
                      max-height="400"
                      hint="A pesquisa é realizada nos campos Título, Palavras-chave, Resumo, Apresentação, Justificativa, Caracterização do público-alvo, Objetivo geral, Objetivos específicos, Metodologia, Forma de avaliação, Infraestrutura física e Informações adicionais."
                      persistent-hint
                      clearable>
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

                <v-layout v-if="pesquisaAvancada" row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Unidade'
                      :items="listaUnidades"
                      eager
                      v-model="pesquisa.unidade"
                      item-text="nomeSigla"
                      item-value="id"
                      prepend-icon="account_balance"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Tipo de público-alvo'
                      :items="listaTipoPublico"
                      eager
                      v-model="pesquisa.tipoPublico"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="people"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout v-if="pesquisaAvancada && pesquisa.unidade" row wrap justify-space-between>
                  <v-flex xs11 sm2>
                    <v-checkbox v-model="simples">
                      <template v-slot:label>
                        <div class="v-checkbox_label">Consulta simples por unidade &nbsp</div>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                            >info</v-icon>
                          </template>
                          <span>Na consulta simples, são retornadas apenas as ações de extensão que estão imediatamente vinculadas à unidade selecionada.</span>
                        </v-tooltip>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout v-if="pesquisaAvancada" row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Principal Área Temática de Extensão'
                      :items="listaAreaTematica"
                      eager
                      v-model="pesquisa.principalAreaTematicaExtensao"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Área Temática de Extensão Afim'
                      :items="listaAreaTematicaAfim.slice(1)"
                      eager
                      v-model="pesquisa.areaTematicaExtensaoAfim"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>

                </v-layout>

                <v-layout v-if="pesquisaAvancada" row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Linha de Extensão'
                      :items="listaLinhaExtensao"
                      eager
                      v-model="pesquisa.linhaExtensao"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Grande Área do Conhecimento'
                      :items="listaGrandeArea"
                      eager
                      v-model="pesquisa.grandeAreaConhecimento"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout v-if="pesquisaAvancada" row wrap justify-space-between>
                  <v-flex>
                    <v-select
                      label='Principal Objetivo de Desenvolvimento Sustentável'
                      :items="listaODS.slice(0,17)"
                      eager
                      v-model="pesquisa.principalObjetivoDesenvolvimentoSustentavel"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout v-if="pesquisaAvancada" row wrap justify-space-between>
                  <v-flex>
                    <v-select
                      label='Objetivo de Desenvolvimento Sustentável Afim'
                      :items="listaODSAfim.slice(0,17)"
                      eager
                      v-model="pesquisa.objetivoDesenvolvimentoSustentavelAfim"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      clearable
                      autocomplete
                      chips
                      multiple>
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout v-if="pesquisaAvancada" row wrap>
                  <v-flex xs11 sm5>
                    <c-date-menu label="Período - Início" v-model="pesquisa.periodoInicio" clearable></c-date-menu>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs11 sm5>
                    <c-date-menu label="Período - Término" v-model="pesquisa.periodoTermino" clearable></c-date-menu>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-end>
                  <v-btn v-if="!pesquisaAvancada" color="primary" text @click="abrirPesquisaAvancada">Pesquisa avançada</v-btn>
                  <v-btn v-else color="primary" text @click="fecharPesquisaAvancada">Pesquisa simples</v-btn>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12 style="padding-top:15px">
                    <div align="center">
                      <v-btn style="margin-right: 10px;" color="primary" @click="limpar">Limpar</v-btn>
                      <v-btn color="primary" @click="pesquisar">Pesquisar</v-btn>
                    </div>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
          </v-card-text>
        </v-card>

        <br><br><br><br>

        <v-card class="text-xs-center">
          <basic-toolbar :title="'Resultados da Pesquisa'"></basic-toolbar>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="listaProjetos"
            :search="search"
            :no-data-text="'Nenhum projeto encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.titulo="props">
                <router-link target="_blank" :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{props.item.titulo}}</router-link>
              </template>
              <template v-slot:item.nomeUnidade="props">{{unidade.format(props.item.nomeUnidade,props.item.siglaUnidade)}}</template>
              <template v-slot:item.dataInicio="props">{{dates.format(props.item.dataInicio)}}</template>
              <template v-slot:item.dataConclusao="props">{{dates.format(props.item.dataConclusao)}}</template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} projetos
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import dates from '@/utils/dates'
  import unidade from '@/utils/unidade'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      unidade: unidade,
      pesquisaAvancada: false,
      listaSituacao: [],
      listaSituacao2: [
        { 'item': 18, 'descricao': 'Ativo' },
        { 'item': 4, 'descricao': 'Suspenso' },
        // { 'item': 20, 'descricao': 'Aguardando envio de relatório' },
        // { 'item': 22, 'descricao': 'Relatório aguardando aprovação' },
        { 'item': 19, 'descricao': 'Concluído' }

      ],
      listaTipoPublico: [],
      listaUnidades: [],
      listaTipo: [
        {
          'id': 39725,
          'classificacaoItem': 90,
          'tipoClassificacao': 'Classificação Primária',
          'descricao': 'Extensão'
        }
      ],
      listaSubtipo: [
        {
          'id': 39730,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Evento de Extensão'
        }, {
          'id': 39731,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Prestação de Serviço'
        }, {
          'id': 39733,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Programa de Extensão'
        }, {
          'id': 39734,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Projeto de Extensão'
        }, {
          'id': 44194,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Curso de Extensão'
        }, {
          'id': 44195,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Oficina de Extensão'
        },
        {
          'id': 39729,
          'classificacaoItem': 91,
          'tipoClassificacao': 'Classificação Secundária',
          'descricao': 'Curso/Oficina (antigo)'
        }
      ],
      listaFuncaoParticipante: [],
      listaAreaTematica: [],
      listaAreaTematicaAfim: [],
      listaODS: [],
      listaODSAfim: [],
      listaLinhaExtensao: [],
      listaGrandeArea: [],
      pesquisa: {
        numero: null,
        titulo: '',
        membroEquipe: '',
        funcaoParticipante: null,
        situacao: null,
        palavraChave: '',
        tipoProjeto: 39725,
        subtipoProjeto: null,
        principalAreaTematicaExtensao: null,
        areaTematicaExtensaoAfim: null,
        linhaExtensao: null,
        grandeAreaConhecimento: null,
        periodoInicio: '',
        periodoTermino: '',
        observacoes: '',
        tipoPublico: null,
        hierarquica: true
      },
      listaProjetos: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      simples: false,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Unidade', align: 'center', value: 'nomeUnidade' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Início', align: 'center', value: 'dataInicio' },
        { text: 'Término', align: 'center', value: 'dataConclusao' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      limpar () {
        this.pesquisa = { tipoProjeto: 39725 }
      },
      pesquisar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
        this.pesquisa.hierarquica = !this.simples
        projetos.getConsultaProjetos(this.pesquisa)
        .then(response => {
          this.listaProjetos = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaProjetos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
        })
      },
      truncate (string, limit) {
        if (string.length > limit) return string.substring(0, limit) + '...'
        else return string
      },
      carregarUnidades: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
        projetos.getUnidadesExtensao()
        .then(response => {
          this.listaUnidades = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaUnidades = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
        })
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()

          if (atributo === 'listaSituacao') { // exclui Aguardando envio de relatório (20), Relatório aguardando aprovação (22)
            aqui[atributo] = aqui[atributo].filter(
              item => item.item !== 20 && item.item !== 22
            )
          }
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      },
      obterClassificacoes: function (itemTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        })
      },
      carregarCampos: function () {
        this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico')
        this.carregarUnidades()
        this.obterClassificacoes(100, this, 'listaAreaTematica')
        this.obterClassificacoes(110, this, 'listaAreaTematicaAfim')
        this.obterClassificacoes(111, this, 'listaLinhaExtensao')
        this.obterClassificacoes(112, this, 'listaGrandeArea')
        this.obterClassificacoes(103, this, 'listaODS')
        this.obterClassificacoes(104, this, 'listaODSAfim')
      },
      abrirPesquisaAvancada () {
        this.carregarCampos()
        this.pesquisaAvancada = true
      },
      fecharPesquisaAvancada () {
        this.pesquisaAvancada = false
      }
    },
    mounted () {
      // this.obterClassificacoes(90, this, 'listaTipo')
      // this.obterClassificacoes(91, this, 'listaSubtipo')
      this.opcoesTabelaEstruturada(6011, this, 'listaSituacao')
      this.opcoesTabelaEstruturada(6003, this, 'listaFuncaoParticipante')
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .v-checkbox_label {
    font-size: 10.5pt;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// consulta-projetos.vue?4d9f28ab